const STORAGE_KEY = 'es_ra_failed_prompts'
const MAX = 50

export type RiskAnalystMiss = {
  utterance: string
  reason: string
  at: string
}

/** Client-side ring buffer of unsupported / fallthrough prompts for routing coverage (#7). */
export function logRiskAnalystMiss(utterance: string, reason: string): void {
  const entry: RiskAnalystMiss = {
    utterance: utterance.slice(0, 500),
    reason,
    at: new Date().toISOString(),
  }
  try {
    console.warn('[RiskAnalyst miss]', reason, utterance)
    const raw = sessionStorage.getItem(STORAGE_KEY)
    const prev: RiskAnalystMiss[] = raw ? (JSON.parse(raw) as RiskAnalystMiss[]) : []
    const next = appendMissRing(prev, entry)
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next))
  } catch {
    // ignore storage failures
  }
}

export function readRiskAnalystMisses(): RiskAnalystMiss[] {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? (JSON.parse(raw) as RiskAnalystMiss[]) : []
  } catch {
    return []
  }
}

export function clearRiskAnalystMisses(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore storage failures
  }
}

/** Pure ring-buffer helper (testable without sessionStorage). */
export function appendMissRing(
  prev: RiskAnalystMiss[],
  entry: RiskAnalystMiss,
  max = MAX
): RiskAnalystMiss[] {
  return [...prev, entry].slice(-max)
}
